import React, { useEffect, useRef, useState } from 'react'
import { Button, message } from 'antd'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from '@/components/YhFormBox/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText, momentFormat } from '@/utils/utils'
import { useDictModel, ITreeSelectData } from '../../../dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import moment from 'moment'
import { YHDetailNav } from '@/components/YHDetailNav'
import { assetsArchivesModel } from '../../assetsArchivesModel'
import { ISelectOptions } from '@/types/AppTypes'

export const BaseAssetsArchivesDetails = () => {
    const { getSelectedDictOne,getTreeNodeName } = useDictModel(() => []);
    const {editFormVal,selectedRowKeys,setEditFormVal} = assetsArchivesModel()
    const { selectedNavId, replaceNav, getSelectedNavState } = useNavModel(({ selectedNavId }) => [selectedNavId])
    const formRef = useRef<IYhFormRef>()
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)

    //编辑时， 没有缓存调用详情接口
    useEffect(() => {
            setEditFormVal({...selectedRowKeys,createTime:selectedRowKeys.createTime?momentFormat(selectedRowKeys.createTime):''})
    }, [detailsInfo])


    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, '4-2')
    }


    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '物资编码',
                fieldName: 'code',
                disable: true,
                placeholder: '自动生成',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '物资名称',
                fieldName: 'name',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "品牌",
                fieldName: "brandName",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '物资类型',
                fieldName: 'typeName',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '规格型号',
                fieldName: 'model',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '单位',
                fieldName: 'unitName',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '进货价',
                fieldName: 'purchasePrice',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '物资条码',
                fieldName: 'code',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '备注',
                fieldName: 'note',
                span:12
            },
        ],
    }
    const otherFormItem: IYhFormItemsBox = {
        title: '其它信息',
        style: {marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '创建人',
                placeholder: '自动生成',
                fieldName: 'createUser',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '创建时间',
                placeholder: '自动生成',
                fieldName: 'createTime',
                disable: true,
            },{
                type: FormItemTypeEnum.Input,
                fieldLabel: '修改人',
                placeholder: '自动生成',
                fieldName: 'updateUser',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '修改时间',
                placeholder: '自动生成',
                fieldName: 'updateTime',
                disable: true,
            },
        ],
    }
    const AssetsArchivesFromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        formValues: editFormVal,
        boxs: [baseFormItem,otherFormItem],
        disabled:true
    }

    const action = (
        <>
            <Button className="mr-10" shape="round" onClick={onClose} style={{ float: 'right' }}>
                返回
            </Button>
        </>
    )

    return (
        <>
            <YHDetailNav title='物资档案详情' btns={action} style={{ marginBottom: '8px' }} />
            <YhFormBox {...AssetsArchivesFromConfig} />
        </>
    )
}
